<template>
<div class="list-list">
    <div style="position:relative;">
        <v-text-field ref="search" filled dense rounded placeholder="Search..." style="margin:6px 8px" v-model="search" hide-details @focus="$event.target.select()" />
    </div>
    <div style="flex-grow:1;overflow-y:auto;">
        <v-list-item-group>
            <slot name="top"></slot>
            <v-list-item :class="{selected: isSelected(item)}" :input-value="value && item._id == value._id" @click="select(item)" v-for="(item, idx) in itemsList" :key="idx">
                <v-list-item-content>
                    <v-list-item-title>
                        {{item.title || item.name || item.text}}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{item.value || item.details || item.text}}
                    </v-list-item-subtitle>

                </v-list-item-content>
            </v-list-item>
            <slot name="bottom"></slot>
        </v-list-item-group>
    </div>
</div>
</template>

<script>

import EditableText from '@/ui-elements/EditableText'
import Utilities from '../../helpers/Utilities'


export default {
    data() {
        return {
            search: null,
        }
    },

    components: {
        EditableText,
    },
    
    props: {
        items: Array,
        value: {
            type: Object,
            default: function() {
                return this.items[0]
            }
        },
        displayField: {
            type: String,
            default: 'title'
        }
    },

    computed: {
        selectedIndex: {
            get() {
                if(!this.selectedItem)
                    return null
                return this.items.findIndex(o => o._id == this.selectedItem._id)
            },
            set(newVal) {
                this.select(this.items[newVal])
            }
        },

        itemsList() {
            if(!this.search) {
                return this.items
            }
            return this.items.filter(item => this.objectContains(item, this.search))
        },
    },

    methods: {
        isSelected(item) {
            if(!item || !this.value)
                return false
            return (this.value._id == item._id)
        },
        select(item) {
            this.$emit('input', item)
            this.$emit('click', item)
        },
        objectContains(obj, search) {
            let result = false
            Object.entries(obj).forEach(entry => {
                const [key, val] = entry
                if(key != '_id' && val && val.contains && val.contains(search))
                    result = true
            })
            return result
        },  
        focusSearch() {
            Utilities.focus(this, 'search')
        }      
    },

    created() {

    }
}
</script>

<style scoped>
    .list-list {
        height:100%;
        display:flex;
        flex-direction:column;
    }

    .selected {
        background-color:#eee;
    }
   
</style>




// WEBPACK FOOTER //
// ListList.vue?a96f2c1e